import React from 'react';
import { NodeViewWrapper, ReactNodeViewProps } from '@tiptap/react';

export const MentionNodeView: React.FC<ReactNodeViewProps> = ({ node }) => {
  return (
    <NodeViewWrapper className="mention">
      <span className="mention-label">@{node.attrs.label ?? 'Unknown User'}</span>
    </NodeViewWrapper>
  );
};
